import React from 'react';
import { IconProps } from './model/IconInterface';

const TruckIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <path d='M1 8h11v9H1z' />
        <path d='M12 11h5l3 3v3h-8z' />
        <circle cx='5.5' cy='17.5' r='1.8' />
        <circle cx='16.5' cy='17.5' r='1.8' />
    </svg>
);

export default TruckIcon;
